<div class="bowling-summary" *ngIf="state">
  <div class="winner-banner" [class.tie]="isTie">
    <div class="trophy">🏆</div>
    <span class="winner-text">{{ winnerLabel() }}</span>
    <span class="margin-text" *ngIf="!isTie">{{ marginText() }}</span>
  </div>

  <div class="final-scorecards">
    <div class="final-card"
         *ngFor="let p of state.participants; let i = index"
         [class.is-winner]="state.winnerSide === i"
         [style.--side-color]="p.color">
      <div class="final-header">
        <span class="final-name">{{ getName(p) }}</span>
        <span class="final-total">{{ p.totalScore | arabicNumber:currLang }}</span>
      </div>

      <app-bowling-scorecard
        [participant]="p"
        [isActive]="false"
        [currLang]="currLang">
      </app-bowling-scorecard>

      <div class="final-stats">
        <div class="stat">
          <span class="stat-v">{{ countStrikes(p) | arabicNumber:currLang }}</span>
          <span class="stat-l">{{ currLang === 'ar' ? 'ضربات' : 'Strikes' }}</span>
        </div>
        <div class="stat" *ngIf="!isOneVsOne">
          <span class="stat-v">{{ p.students.length | arabicNumber:currLang }}</span>
          <span class="stat-l">{{ currLang === 'ar' ? 'لاعبون' : 'Bowlers' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
